module.exports = __webpack_public_path__ + "img/img4.33bc0c08.png";